import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import type { Id } from '@e-socna/data-layer';

import { CheckboxList } from '../../components/CheckboxList';
import { useFormikOnNextTick } from '../../hooks/useFormikOnNextTick.hook';

import { getInitialSelectedOptionGroupIds } from './utils/quotation-option-groups.util';
import type { QuotationOptionGroup } from './utils/quotation-option-groups.util';
import { InfoAlert } from '../../components/InfoAlert';

interface OptionGroupsValues {
  readonly selectedOptionGroupIds?: readonly Id[];
}

interface Props {
  readonly initialSelectedOptionGroupIds?: readonly Id[] | null;
  readonly optionGroups: readonly QuotationOptionGroup[];
}

export const QuotationOptionGroupsFields = ({
  initialSelectedOptionGroupIds,
  optionGroups,
}: Readonly<Props>) => {
  const { setFieldValue, values } = useFormikContext<OptionGroupsValues>();
  const { setFieldValue: setFieldValueOnNextTick } = useFormikOnNextTick();

  useEffect(() => {
    if (values.selectedOptionGroupIds) {
      return;
    }

    setFieldValueOnNextTick(
      'selectedOptionGroupIds',
      getInitialSelectedOptionGroupIds({
        initialSelectedOptionGroupIds,
        optionGroups,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack spacing={1}>
      <Typography variant="h6">Options retenues par le client</Typography>
      <InfoAlert>
        Seules les options cochées seront prises en compte dans le total du
        devis et en comptabilité.
      </InfoAlert>
      <CheckboxList<Id>
        idPrefix="quotation-option-groups-"
        items={optionGroups}
        // eslint-disable-next-line react/jsx-no-bind
        onChange={(selectedOptionGroupIds) => {
          void setFieldValue('selectedOptionGroupIds', selectedOptionGroupIds);
        }}
        value={values.selectedOptionGroupIds ?? []}
        variant="edition"
      />
    </Stack>
  );
};
